import React, { useState } from "react";

export default function EduUnityDealsForm() {
  const [product, setProduct] = useState("");
  const [customProduct, setCustomProduct] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [neighbourhood, setNeighbourhood] = useState("");
  const [dealers, setDealers] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState("");
  const [showAbout, setShowAbout] = useState(false); 

  const productOptions = [
    "School Bags",
    "Uniforms",
    "Textbooks",
    "Stationery",
    "Shoes",
    "Not In The List",
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (product === "Not In The List" && customProduct.trim() === "") {
      alert("Please specify the product if 'Not In The List' is selected.");
      return;
    }
    alert(
      `Form Submitted:\nProduct: ${
        product === "Not In The List" ? customProduct : product
      }\nPIN: ${pinCode}\nNeighbourhood: ${neighbourhood}\nDealer: ${selectedDealer}`
    );
  };

  const handleGetSeller = () => {
    if (pinCode.trim() || neighbourhood.trim()) {
      // Dummy dealer names
      setDealers([
        "ABC School Supplies",
        "EduMart Stationers",
        "Knowledge Hub Traders",
      ]);
    } else {
      alert("Please enter either PIN Code or Neighbourhood.");
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-gray-600 shadow-lg rounded-2xl relative">
      <h2 className="text-xl font-bold mb-4 text-white">
        UnityDeals - School Products
      </h2>

      {/* About UnityDeals Button */}
      <button
        type="button"
        onClick={() => setShowAbout(true)}
        className="mb-4 bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700"
      >
        About UnityDeals
      </button>

      {/* Popup Modal */}
      {showAbout && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-blue-600 p-6 rounded-2xl max-w-2xl shadow-xl overflow-y-auto max-h-[80vh]">
            <h3 className="text-2xl font-bold mb-4 text-center text-yellow-100">
              About UnityDeals – Education & Learning
            </h3>
            <div className="space-y-4 text-white text-sm leading-relaxed">
              <p>
                Education is getting more expensive every year—furniture, books,
                uniforms, smart classrooms, laptops—everything adds up. Schools,
                parents, and teachers often pay more because they buy
                individually, while suppliers struggle to reach enough customers
                efficiently.
              </p>
              <p>
                <b>UnityDeals by Think5Whys</b> solves this problem. We bring
                buyers together, pool their needs, negotiate with verified
                suppliers, and deliver end-to-end fulfillment. The result?{" "}
                <b>
                  Lower costs for buyers, assured business for suppliers, and
                  transparent transactions for everyone.
                </b>
              </p>

              <ul className="list-disc pl-5">
                <li>
                  <b>Schools & Institutions:</b> Save 15–25% on benches, books,
                  and lab kits.
                </li>
                <li>
                  <b>Teachers & Training Centers:</b> Smart classroom bundles
                  10–20% cheaper.
                </li>
                <li>
                  <b>Parents & Students:</b> Laptops & study kits at lower
                  prices.
                </li>
                <li>
                  <b>Vendors:</b> Pre-verified bulk demand, fewer negotiations,
                  recurring sales.
                </li>
              </ul>

              <h4 className="text-lg font-semibold mt-4">
                How It Works (Simple 4 Steps)
              </h4>
              <ol className="list-decimal pl-5 space-y-1">
                <li>Select Need – choose product or request custom.</li>
                <li>Join Buyer Pool – combine demand with others.</li>
                <li>
                  Deal Negotiation – UnityDeals secures the best group price.
                </li>
                <li>
                  Fulfillment & Payment – Delivery managed, payment released
                  after satisfaction.
                </li>
              </ol>
            </div>

            {/* Close Button */}
            <div className="mt-6 text-center">
              <button
                onClick={() => setShowAbout(false)}
                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-4 text-white">
        {/* Product Dropdown */}
        <div>
          <label className="block font-medium mb-1">Select Product</label>
          <select
            value={product}
            onChange={(e) => setProduct(e.target.value)}
            className="h-10 w-full border p-2 rounded text-black"
          >
            <option value="">-- Choose a Product --</option>
            {productOptions.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        {/* Custom Product Input */}
        {product === "Not In The List" && (
          <div>
            <label className="block font-medium mb-1">Specify Product</label>
            <input
              type="text"
              value={customProduct}
              onChange={(e) => setCustomProduct(e.target.value)}
              placeholder="Enter your product"
              className="h-10 w-full border p-2 rounded text-black"
            />
          </div>
        )}

        {/* PIN Code Input */}
        <div>
          <label className="block font-medium mb-1">PIN Code</label>
          <input
            type="text"
            value={pinCode}
            onChange={(e) => setPinCode(e.target.value)}
            placeholder="Enter PIN Code"
            className="w-full border p-2 rounded text-black"
          />
        </div>

        {/* Neighbourhood Input */}
        <div>
          <label className="block font-medium mb-1">Neighbourhood</label>
          <input
            type="text"
            value={neighbourhood}
            onChange={(e) => setNeighbourhood(e.target.value)}
            placeholder="Enter Neighbourhood"
            className="w-full border p-2 rounded text-black"
          />
        </div>

        {/* Get Seller Button */}
        <button
          type="button"
          onClick={handleGetSeller}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Get Seller Name
        </button>

        {/* Dealer Dropdown */}
        {dealers.length > 0 && (
          <div>
            <label className="block font-medium mb-1">Select Dealer</label>
            <select
              value={selectedDealer}
              onChange={(e) => setSelectedDealer(e.target.value)}
              className="h-10 w-full border p-2 rounded text-black"
            >
              <option value="">-- Choose Dealer --</option>
              {dealers.map((dealer) => (
                <option key={dealer} value={dealer}>
                  {dealer}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Submit Button */}
        <button
          type="submit"
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          Submit
        </button>
      </form>
    </div>
  );
}
